document.addEventListener('click', function (e) {
  // 打开弹窗
  const trigger = e.target.closest('.popup-trigger');
  if (trigger) {
    const popupId = trigger.getAttribute('data-popup');
    const popup = document.querySelector(`.popup-content-wrapper[data-popup-id="${popupId}"]`);
    if (popup) {
      popup.classList.remove('hidden');
    }
    return; // 避免事件继续向下判断
  }

  // 关闭弹窗（兼容 SVG 点击）
  const closeBtn = e.target.closest('.popup-close');
  if (closeBtn) {
    const popup = closeBtn.closest('.popup-content-wrapper');
    if (popup) {
      popup.classList.add('hidden');
    }
  }
});
